import DeckRoadwayEditor from "../outputs/ui/DeckRoadway/DeckRoadwayEditor";
import React, {useEffect, useState} from "react";
import PierEditor from "../outputs/ui/Pier/PierEditor";

export default function BridgeUI({br}) {
    const [pier, setPier] = useState({
        name: '', title: ''
    })

    useEffect(() => {
        if(!pier.name && br?.pier_data?.length > 0)
            setPier({
                name: br?.pier_data[0]?.pier_name,
                title: br?.pier_data[0]?.title,
            })
    }, [br]);

    return (
        <div style={{display: 'flex', gap: 32, flex: 'wrap'}}>
            <DeckRoadwayEditor
                windowName={'deck-base'}
                data={br?.deck_dist_data?.base}
                title={br?.deck_dist_data?.base_title}
            />

            <PierEditor
                windowName={'pier-base'}
                data={br?.pier_data}
                selectedPier={pier.name}
                title={pier.title}
                onChangePier={(value) => setPier({
                    name: value,
                    title: pier.title
                })}
            />
        </div>
    )
}